module.exports = __webpack_public_path__ + "img/placement_body_front.da00cde8.png";